export enum SourceTypes {
  Vendor = 'vendors',
  ProductOrgsAndSubGroups = 'product',
  ProductInfo = 'product_information',
  ProductRelations = 'product_relation',
  ProductItems = 'product_item_detail',
  ProductGateways = 'gateway_item_detail',
  Coupon = 'coupons',
}
